import { Link, CurrencyDisplay, Text, HTML } from '@pega/cosmos-react-core';
import type { TimelineProps } from '@pega/cosmos-react-work';

export const activity: TimelineProps['activity'] = [
  {
    id: '1',
    date: Date.UTC(2025, 2, 20, 19, 28, 22),
    title: 'Email blast: "Buy today"',
    icon: 'bell-off-solid',
    content: [
      {
        id: '11',
        name: 'Progress and Risk',
        value: <HTML content='<ul><li>Progress</li><li>Risk</li></ul>' />
      }
    ]
  },
  {
    id: '2',
    date: Date.UTC(2025, 2, 20, 18, 6, 22),
    title: 'Confirm eligibility',
    icon: 'circle-stacked-mixed'
  },
  {
    id: '3',
    date: Date.UTC(2023, 2, 10, 9, 26, 22),
    title: 'Review customer bill',
    status: { variant: 'pending', children: 'Wait' }
  },
  {
    id: '4',
    date: Date.UTC(2022, 7, 10, 18, 6, 22),
    title: 'Confirm eligibility',
    icon: 'circle-stacked-mixed'
  },
  {
    id: '5',
    date: Date.UTC(2022, 6, 18, 0, 1, 22),
    title: (
      <Link href='https://www.pega.com' target='_blank'>
        Visit Pega
      </Link>
    )
  },
  {
    id: '6',
    date: Date.UTC(2021, 6, 10, 13, 20, 22),
    title: 'Update plat',
    icon: 'bulb-solid',
    status: { variant: 'success', children: 'Good' }
  },
  {
    id: '7',
    date: Date.UTC(2021, 1, 20, 13, 20, 22),
    title: 'Sent over request',
    icon: 'bulb-solid',
    defaultExpanded: true,
    status: { variant: 'success', children: 'Good' },
    content: [
      { id: '31', name: 'Date range', value: <Text>Jan 1, 2021 - May 3, 2021</Text> },
      {
        id: '32',
        name: "What's next",
        value: (
          <Text>
            We will fulfill your request within 3 business days. You will receive your statement
            copy via mail at 23 Main St. Boston, MA.
          </Text>
        )
      },
      {
        id: '33',
        name: 'Current due amount',
        value: <CurrencyDisplay value={1343.45} currencyISOCode='USD' />
      }
    ]
  },
  {
    id: '8',
    date: Date.UTC(2021, 1, 20, 13, 19, 22),
    title: 'Fulfill customer request for last month’s billing statement',
    icon: 'layers',
    status: { variant: 'pending', children: 'Wait' },
    content: [
      { id: '41', name: 'Date range', value: <Text>Jan 1, 2021 - May 3, 2021</Text> },
      {
        id: '42',
        name: "What's next",
        value: (
          <Text>
            We will fulfill your request within 3 business days. You will receive your statement
            copy via mail at 23 Main St. Boston, MA.
          </Text>
        )
      },
      {
        id: '43',
        name: 'Current due amount',
        value: <CurrencyDisplay value={121} currencyISOCode='USD' />
      }
    ]
  },
  {
    id: '9',
    date: Date.UTC(2021, 1, 20, 0, 1, 22),
    title: (
      <Link href='https://community.pega.com/support' target='_blank'>
        Visit Pega support for assistance
      </Link>
    )
  },
  {
    id: '10',
    date: Date.UTC(2021, 1, 19, 13, 20, 22),
    title: 'Sent over request',
    icon: 'bulb-solid',
    status: { variant: 'success', children: 'Good' },
    content: [
      { id: '61', name: 'Date range', value: <Text>Jan 1, 2021 - May 3, 2021</Text> },
      {
        id: '62',
        name: "What's next",
        value: (
          <Text>
            We will fulfill your request within 3 business days. You will receive your statement
            copy via mail at 23 Main St. Boston, MA.
          </Text>
        )
      },
      {
        id: '64',
        name: 'Current due amount long label',
        value: <CurrencyDisplay value={248.87} currencyISOCode='USD' />
      }
    ]
  },
  {
    id: '11',
    date: Date.UTC(2021, 1, 17, 36, 20, 22),
    title: 'Initial claim received',
    status: { variant: 'pending', children: 'Wait' }
  },
  {
    id: '12',
    date: Date.UTC(2020, 12, 15, 13, 19, 22),
    title: 'Balance inquiry',
    icon: 'phone-solid',
    status: { variant: 'pending', children: 'Wait' }
  },
  {
    id: '13',
    date: Date.UTC(2020, 2, 20, 19, 28, 22),
    title: 'Email blast: "Best Offer"',
    icon: 'bell-off-solid'
  },
  {
    id: '14',
    date: Date.UTC(2020, 1, 12, 10, 25, 48),
    title: 'Receive customer bill',
    icon: 'layers',
    status: { variant: 'success', children: 'Good' }
  }
];
